<script>
	import { isCXTSRole } from "src/utils/misc";
	import QuotationDisplay from "./QuotationDisplay.svelte";
	import QuotationInput from "./QuotationInput.svelte";

	export let state = "view"; // possible values: "view", "edit", "create"
	export let caseDetails = {};
	export let form;
	export let caseType;
	export let accidentGIAReportNo;
	export let claimType;
	export let selectedSides;
	export let liabilityType;
	export let noOfRepairDays;
	export let actualRepairCost;
	export let remarks;
	export let costBreakdownItems;
	export let dateReported;
	export let incidentDateTime;
	export let tnsRemarks;

	function quotationEditBool() {
		return (
			(isCXTSRole(caseDetails.createdFrom) ||
				caseDetails.createdFrom === "Desmond" ||
				caseDetails.createdFrom === "Operator" ||
				caseDetails.caseOrigin === "Operator") &&
			caseDetails.status !== "PreBilling" &&
			caseDetails.status !== "Closed" &&
			caseDetails.status !== "Investigating" &&
			caseDetails.status !== "Approving"
		);
	}
</script>

{#if state === "create" || state === "edit" || quotationEditBool()}
	<QuotationInput
		{form}
		{caseType}
		{accidentGIAReportNo}
		{claimType}
		{selectedSides}
		{liabilityType}
		{noOfRepairDays}
		{actualRepairCost}
		{remarks}
		{costBreakdownItems}
		{caseDetails}
		{dateReported}
		{state}
		{tnsRemarks}
	/>
{:else}
	<QuotationDisplay {caseDetails} {form} {tnsRemarks} />
{/if}
